module.exports = __webpack_public_path__ + "static/media/PARTICIPACION_8.b7e40919.png";